// Google Analytics 4, gated behind cookie consent (Consent Mode v2).
//
// The consent DEFAULT (everything denied) and the `gtag` stub are set in
// public/index.html BEFORE this module runs, so gtag.js is never downloaded
// until the user explicitly opts in. Everything here no-ops gracefully when
// REACT_APP_GA_MEASUREMENT_ID is not configured.

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export const analyticsConfigured = Boolean(GA_ID);

let scriptInjected = false;

const loadGtagScript = (): void => {
  if (scriptInjected || !GA_ID || typeof window.gtag !== 'function') return;
  scriptInjected = true;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { anonymize_ip: true });
};

/** Grant analytics consent and start loading GA. No-op without a GA id. */
export const grantAnalytics = (): void => {
  if (!GA_ID || typeof window.gtag !== 'function') return;
  window.gtag('consent', 'update', { analytics_storage: 'granted' });
  loadGtagScript();
};

/** Revoke analytics consent. */
export const denyAnalytics = (): void => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('consent', 'update', { analytics_storage: 'denied' });
};

/** Send a SPA page_view on route change (only fires once GA is loaded + consented). */
export const trackPageView = (path: string): void => {
  if (!GA_ID || !scriptInjected || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};
